import React from 'react';
import { OriginIcon, OriginIconProps } from './OriginIcon';

export function createIcon(displayName: string, path: React.ReactElement<any> | React.ReactElement<any>[]) {
  return (props: OriginIconProps) => (
    <OriginIcon name={`${displayName}Icon`} {...props}>
      {path}
    </OriginIcon>
  );
}
